module.exports = __webpack_public_path__ + "media/images/evaluaciones-bd4682cd4d7835a4a43663e022bf7f26.png";